export default function Strengths() {
  const strengths = [
    {
      icon: 'ri-tools-line',
      title: '製造現場での実務経験',
      description: '大手製造業で10年以上の現場経験があり、製造工程の課題や改善ポイントを深く理解しています。IT・AIの専門用語ではなく、現場の言葉でコミュニケーションします。'
    },
    {
      icon: 'ri-cpu-line',
      title: '最新AI技術の開発力',
      description: 'AI開発企業での実績を活かし、画像認識、予測分析、自然言語処理など、幅広いAI技術を製造業の課題解決に応用できます。'
    },
    {
      icon: 'ri-map-pin-line',
      title: '中小企業の製造業を支援',
      description: '中小製造業支援に特化し、現場に足を運んで課題をヒアリング。大企業向けの画一的なソリューションではなく、御社に最適な提案を行います。'
    },
    {
      icon: 'ri-hand-heart-line',
      title: '伴走型の継続支援',
      description: '導入して終わりではなく、運用開始後も継続的にサポート。効果測定や改善提案を通じて、AI活用を成功に導きます。'
    }
  ];

  return (
    <section className="bg-[#FAFBFC] py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-4xl font-black text-[#1A3A5C] mb-4">EngiMindの強み</h2>
          <p className="text-[#4A5568] text-lg">
            製造業出身のAIエンジニアだからこそ、現場の課題を深く理解できます
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {strengths.map((strength, index) => (
            <div
              key={index}
              className={`bg-[#F0F4F8] rounded-3xl p-10 ${
                index === 0 ? 'shadow-lg' : 'shadow-md'
              } hover:shadow-xl transition-shadow duration-300`}
            >
              <div className="mb-4">
                <i className={`${strength.icon} text-4xl text-[#1A3A5C]`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A3A5C] mb-4">{strength.title}</h3>
              <p className="text-[#4A5568] text-base leading-relaxed">{strength.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}